module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrapper",
    attrs: {
      "align": "center"
    }
  }, [_c('ContactUsHeader'), _vm._v(" "), (_vm.hasBeenDisabledSignUp === 'ON') ? _c('h4', {
    staticClass: "text-center"
  }, [_vm._m(0)]) : _c('h4', {
    staticClass: "text-center"
  }, [_c('strong', [_vm._v("Register to create a new investment account below")])]), _vm._v(" "), _c('div', {
    staticClass: "block-center mt-sm wd-xl"
  }, [(_vm.hasBeenDisabledSignUp === 'ON') ? _c('p', {
    staticClass: "pt-sm text-center"
  }, [_vm._v("\n            If you are an existing investor,\n              "), _c('router-link', {
    attrs: {
      "to": {
        name: 'Login'
      }
    }
  }, [_vm._v("log in here")]), _vm._v(" or email\n              "), _c('a', {
    attrs: {
      "href": "mailto:info@calvertimpact.org"
    }
  }, [_vm._v("info@calvertimpact.org")]), _vm._v(" for online access.\n          ")], 1) : _vm._e(), _vm._v(" "), (_vm.hasBeenDisabledSignUp === 'OFF') ? _c('div', {
    staticClass: "panel panel-dark panel-flat"
  }, [_c('p', {
    staticClass: "pt-sm text-center"
  }, [_vm._v("\n            If you are an existing investor that has not logged in online before,\n              "), _c('router-link', {
    attrs: {
      "to": {
        name: 'Login'
      }
    }
  }, [_vm._v("log in here")]), _vm._v(" or email\n              "), _c('a', {
    attrs: {
      "href": "mailto:info@calvertimpact.org"
    }
  }, [_vm._v("info@calvertimpact.org")]), _vm._v(" for online access.\n          ")], 1), _vm._v(" "), _c('div', {
    staticClass: "panel-body"
  }, [_c('form', {
    staticClass: "mb-lg",
    attrs: {
      "role": "form",
      "novalidate": ""
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.validateAndSubmitRegistration($event)
      }
    }
  }, [_c('div', {
    staticClass: "form-group has-feedback",
    class: {
      'has-error': _vm.emailError
    }
  }, [_c('label', {
    staticClass: "text-muted",
    attrs: {
      "for": "signupInputEmail1"
    }
  }, [_vm._v("Email address")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.computedEmail),
      expression: "computedEmail"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "signupInputEmail1",
      "type": "email",
      "placeholder": "Enter email",
      "autocomplete": "off",
      "required": ""
    },
    domProps: {
      "value": (_vm.computedEmail)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.computedEmail = $event.target.value
      }
    }
  }), _vm._v(" "), _c('em', {
    staticClass: "form-icon icon-envelope"
  }), _vm._v(" "), _c('span', {
    staticClass: "help-block",
    attrs: {
      "id": "helpBlock2"
    }
  }, [_vm._v(_vm._s(_vm.emailError))])]), _vm._v(" "), _c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.stateError
    }
  }, [_c('label', {
    staticClass: "text-muted",
    attrs: {
      "for": "state"
    }
  }, [_vm._v("State")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.state),
      expression: "state"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "state",
      "placeholder": "Please select",
      "required": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.state = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "selected": ""
    }
  }, [_vm._v("Please select")]), _vm._v(" "), _vm._l((_vm.filteredStates), function(s) {
    return _c('option', {
      key: s.abbreviation,
      domProps: {
        "value": s.abbreviation
      }
    }, [_vm._v(_vm._s(s.name))])
  })], 2), _vm._v(" "), _c('span', {
    staticClass: "help-block",
    attrs: {
      "id": "helpBlock3"
    }
  }, [_vm._v(_vm._s(_vm.stateError))])]), _vm._v(" "), _c('div', {
    staticClass: "form-group has-feedback",
    class: {
      'has-error': _vm.passwordErrors.length > 0
    }
  }, [_c('label', {
    staticClass: "text-muted",
    attrs: {
      "for": "signupInputPassword1"
    }
  }, [_vm._v("Password")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "signupInputPassword1",
      "type": "password",
      "placeholder": "Password",
      "autocomplete": "off",
      "required": ""
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }
    }
  }), _vm._v(" "), _c('em', {
    staticClass: "form-icon icon-lock"
  })]), _vm._v(" "), _c('PasswordHint', {
    attrs: {
      "password": _vm.password
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "form-group has-feedback",
    class: {
      'has-error': _vm.passConfirmationError
    }
  }, [_c('label', {
    staticClass: "text-muted",
    attrs: {
      "for": "signupInputPassword1"
    }
  }, [_vm._v("Confirm password")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.passwordConfirmation),
      expression: "passwordConfirmation"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "signupInputPasswordConfirmation",
      "type": "password",
      "placeholder": "Confirm password",
      "autocomplete": "off",
      "required": ""
    },
    domProps: {
      "value": (_vm.passwordConfirmation)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.passwordConfirmation = $event.target.value
      }
    }
  }), _vm._v(" "), _c('em', {
    staticClass: "form-icon icon-lock"
  }), _vm._v(" "), _c('span', {
    staticClass: "help-block",
    attrs: {
      "id": "helpBlock5"
    }
  }, [_vm._v(_vm._s(_vm.passConfirmationError))])]), _vm._v(" "), _c('vue-recaptcha', {
    ref: "recaptcha",
    attrs: {
      "sitekey": _vm.sitekey
    },
    on: {
      "verify": _vm.onVerify
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "btn btn-block btn-default btn-lg mt-lg",
    attrs: {
      "type": "submit",
      "disabled": !_vm.recaptchaIsVerified
    }
  }, [_vm._v("Create account")]), _vm._v(" "), _c('div', {
    staticClass: "form-group has-feedback",
    class: {
      'has-error': _vm.registrationError
    }
  }, [_c('strong', {
    staticClass: "help-block",
    attrs: {
      "id": "helpBlock6"
    }
  }, [_vm._v(_vm._s(_vm.registrationError))])])], 1)])]) : _vm._e()])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('strong', [_vm._v("Account creation is currently disabled. Please try again later.\n    "), _c('br'), _vm._v(" If you have questions, contact our support at "), _c('a', {
    attrs: {
      "href": "mailto:info@calvertimpact.org"
    }
  }, [_vm._v("info@calvertimpact.org")]), _vm._v(" or 800.248.0337.")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7364621b","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Registration.vue
// module id = 2172
// module chunks = 1